import React from 'react';
import {redirectToUrl} from '../../../../utils/navigation';
import styles from '../Home.module.css';

const ProUpgradeBanner: React.FC = () => (
  <div className={styles.upgradeBanner}>
    <div className="container">
      <div className={styles.upgradeBannerContent}>
        <div className={styles.upgradeBannerDetails}>
          <div className={styles.upgradeBannerTitleRow}>
            <span className={styles.upgradeBannerEmoji}>⭐</span>
            <h3 className={styles.upgradeBannerTitle}>Upgrade to XPSR Pro</h3>
          </div>
          <p className={styles.upgradeBannerCopy}>
            Get verified badge, unlimited uploads, HD video, analytics &amp; more for just $4.99/month
          </p>
        </div>

        <div className={styles.upgradeBannerActionArea}>
          <div className={styles.upgradeBannerPrice}>
            <div className={styles.upgradeBannerPriceLabel}>Starting at</div>
            <div className={styles.upgradeBannerPriceValue}>
              $4.99<span className={styles.upgradeBannerPriceSuffix}>/mo</span>
            </div>
          </div>

          <button
            type="button"
            className={styles.upgradeBannerButton}
            onClick={() => {
              redirectToUrl('/settings?upgrade=1');
            }}
          >
            Start Free Trial
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default React.memo(ProUpgradeBanner);
